module.exports = __webpack_public_path__ + "static/media/57.a4dab6b0.jpg";